import moment from 'moment'
import Store from '@/store'
import { path } from 'ramda'

function Initials(val) {
  return (val || '')
    .split(' ')
    .map(v => v.substring(0, 1))
    .join('')
    .toUpperCase()
}

function Moment(val, format = 'lll') {
  return moment(val).format(format)
}

function Limit(val, limit = 30) {
  if (val.length < limit) return val
  return `${val.substr(0, limit)}...`
}

function Number(val, options = {}) {
  const { locale = 'nb', decimals = 0 } = options
  if ([null, undefined].includes(val)) return
  return val.toLocaleString(locale, { minimumFractionDigits: decimals })
}

function Currency(val, options = {}) {
  const {
    locale = path(['user', 'language'], Store.state) || path(['enums', 'Region', 'language'], Store.state),
    currency = Store.state.enums.Region.currency,
    decimals = 0,
  } = options
  if ([null, undefined].includes(val)) return
  return val.toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
  })
}

const getCurrencySymbol = (currency = Store.state.enums.Region.currency) => {
  const locale = path(['user', 'language'], Store.state) || path(['enums', 'Region', 'language'], Store.state)

  return (0)
    .toLocaleString(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim()
}

export { Initials, Moment, Currency, Number, Limit, getCurrencySymbol }
